export const brokersEspeciales = [
  {id: 'izzi', numInstituto: 8, urlParam: '12345', tema: 'theme-temaIzzi', config: {login: 'loginIZZI', home: 'homeIZZI'}},
  {id: 'gcti', numInstituto: 14, urlParam: 'wqKgj6X', tema: 'theme-temaIzzi', config: {login: 'loginOnSurvey', home: 'homeCGO'}},
];

export const dominiosEspeciales = [
  { dominio: 'plataform.onsurvey.global', numInstituto: 8, tema: 'theme-temaIzzi', config: {login: 'loginOnSurvey', home: 'homeCGO'} },
  { dominio: 'izzi.culturalgo.com', numInstituto: 8, tema: 'theme-temaIzzi-2', config: {login: 'loginOnSurvey', home: 'homeIZZI'} },
  { dominio: 'gptw.culturalgo.com', tema: 'temaFocusArea2', config: {login: 'loginGPTW', home: 'homeGPTW'} },
  { dominio: 'gcti.culturalgo.com', numInstituto: 14, tema: 'theme-temaIzzi', config: {login: 'loginOnSurvey', home: 'homeCGO'} },
  { dominio: 'gcti.onsurvey.global', numInstituto: 14, tema: 'theme-temaIzzi', config: {login: 'loginOnSurvey', home: 'homeCGO'} },
  { dominio: 'itbm.culturalgo.com', tema: 'theme-temaItbm', config: {login: 'loginCGO', home: 'homeCGO'} },
  { dominio: 'itbm.onsurvey.com', tema: 'theme-temaItbm', config: {login: 'loginOnSurvey', home: 'homeCGO'} },
  { dominio: 'innmotion.app', numInstituto: 19, tema: 'theme-temaIzzi', config: {login: 'loginOnSurvey', home: 'homeCGO'} },
  { dominio: 'culturetoinnovate.com', numInstituto: 14, tema: 'theme-temaIzzi', config: {login: 'homeCGO', home: 'homeCGO'} },
  // { dominio: 'localhost', numInstituto: 14, tema: 'theme-blue-gray-dark', config: {login: 'loginIZZI', home: 'homeIZZI'} },
];

export const temasDisponibles = [
  {
    parametro: 'temaprro1',
    tema: 'theme-blue-gray-dark',
    primaryBackground:'fuse-navy-700',
    secondaryBackground: 'fuse-navy-900'
  },
  {
    parametro: 'temaprro2',
    tema: 'theme-pink-dark',
    primaryBackground:'fuse-navy-700',
    secondaryBackground: 'fuse-navy-900'
  },
  {
    parametro: '2uvb4ef',
    tema: 'theme-temaIzzi',
    primaryBackground:'izzi_navBar-700',
    secondaryBackground: 'izzi_navBar'
  },
  {
    parametro: 'temaFocusArea',
    tema: 'temaFocusArea2',
    primaryBackground:'vertical_secundario',
    secondaryBackground: 'vertical_secundario-700'
  },
];

export const fuseConfig = {
  layout: {
    navbar   : {
      hidden: true
    },
    toolbar  : {
      hidden: true
    },
    footer   : {
      hidden: true
    },
    sidepanel: {
      hidden: true
    }
  }
};

export const idiomas = [
  {
    id   : 'en',
    title: 'English',
    flag : 'us',
    short: 'en'
  },
  {
    id   : 'es',
    title: 'Español',
    flag : 'es',
    short: 'es'
  },
  {
    id   : 'tr',
    title: 'Turkish',
    flag : 'tr',
    short: 'tr'
  },
  {
    id   : 'zh1',
    title: 'Traditional Chinese',
    flag : 'zh',
    short: 'zh'
  },
  {
    id   : 'zh2',
    title: 'Simplified Chinese',
    flag : 'zh',
    short: 'zh'
  },
  {
    id   : 'pt',
    title: 'Portuguese',
    flag : 'pt',
    short: 'pt'
  },
  {
    id   : 'de',
    title: 'Alemán',
    flag : 'de',
    short: 'de'
  },
  {
    id   : 'nl',
    title: 'Neerlandés',
    flag : 'nl',
    short: 'nl'
  }

];
